
import DrDocWeb from "./drdocweb.js";


// --
// Node
// Lädt, holt Dr.DOC Node Components
// Requires: DrDocWeb, Bootstrap

if (window.Node !== undefined) {
    console.warn('Lib Duplicate: DrDocNode');
    //return;
}

export default function Node() {

};

//module.exports = Node
//export default Node
window.Node = Node;
Node.ATTR_NAME = 'node-id';
Node.GetElement = function (nodeId, targetElement, allElements) {
    /*
            let targetElement_arr = DrDocWeb.FindChildElements(document.documentElement, Node.ATTR_NAME, nodeId);
            //targetElement = DrDocWeb.FindChildElement(document.documentElement, Node.ATTR_NAME, nodeId);
            if (targetElement_arr !== undefined)
            {
                let targetElement = targetElement_arr[targetElement_arr.length-1];
                return targetElement;
            }
            return undefined;*/
    if (DrDocWeb.IsNullOrEmpty(nodeId))
        return undefined;
    if (typeof nodeId !== 'string')
        return nodeId;

    if (nodeId == Node.GetNodeId(targetElement)) {
        // Angefragte Element war bereits das richtige!
        //console.warn('Node.GetElement: Angefragte Element war bereits das richtige!', nodeId, '  ', targetElement);
        return targetElement;
    }
    // ignoriert normalerweise alle Child-Elements von Elementen mit Attribut "data-form-ignore"
    // Für rekursive Formulare notwendig
    if (allElements === true)
        return DrDocWeb.GetElement(targetElement, '[node-id="' + DrDocWeb.SelectorAttributeEncode(nodeId) + '"]');
    else
        return DrDocWeb.GetElement(targetElement, '[node-id="' + DrDocWeb.SelectorAttributeEncode(nodeId) + '"]:not([data-form-ignore] *)');
};
Node.GetNodeId = function (targetElement) {
    if (targetElement !== undefined && targetElement !== null) {
        if (typeof targetElement === 'string') {
            // annehmen, dass es sich um eine node-id handelt
            return targetElement;
        }

        //console.log('LoadComponent', targetElement);
        let nodeId = targetElement.getAttribute(Node.ATTR_NAME);
        if (nodeId != undefined && nodeId != null)
            return nodeId;
    }
    return undefined;
};

// Lädt eine Komponente in ein DOM-Node
// title, view, sourceElement, targetElement, getData, postData, formFieldsOr, newWindow, ignoreUnloadEvent, requestMethod, ignoreLoadEvent, nav
Node.LoadComponent = function (obj) {

    // title, sourceElement, targetElement, getData, postData, formFieldsOr, newWindow, ignoreUnloadEvent, requestMethod, ignoreLoadEvent
    //console.log('Node.LoadComponent', ' / title:', title, ' / sourceElement:', sourceElement, ' / targetElement:', targetElement, ' / getData:', getData);

    // 1. Target Element und Node-ID laden
    let nodeId = undefined;
    if (obj.targetElement === undefined || obj.targetElement === null) {
        //console.warn('Node.LoadComponent', 'obj.targetElement == undefined');
        //return false;
    }
    else if (typeof obj.targetElement === 'string') {
        // obj.targetElement ist ein String im Format "NodePath"
        nodeId = obj.targetElement;
        obj.targetElement = null;
        // Wenn es sich um kein Smartphone handelt, das obj.targetElement nicht holen, damit ein Modal erstellt wird.
        if (true || !DrDocWeb.IsMobile()) {
            obj.targetElement = Node.GetElement(nodeId); //, obj.sourceElement);
        }
    }
    else {
        // obj.targetElement ist ein DOM Element
        // Node-Path-ID aus 'node-id' Attribut hoeln
        if (obj.targetElement !== undefined && obj.targetElement !== null) {
            //console.log('LoadComponent', obj.targetElement);
            nodeId = Node.GetNodeId(obj.targetElement);
        }
    }

    if (nodeId === undefined || nodeId === null || nodeId.length == 0) {
        console.warn('LoadComponent: Element (obj.targetElement) konnte nicht geladen werden, da keine Node-ID übergeben wurde!', obj);
        return undefined;
    }

    // --
    // 2. Url bauen

    //console.log('Load Com - Target Elem', obj.targetElement, obj.targetElement.innerHTML);

    //let url = target_url !== undefined && target_url.length > 0 ? target_url : window.location.href;
    //console.log('Url', url);
    let url = '/node/' + nodeId;

    // --
    // 3. POST Data
    let hasPostData = false;
    if (obj.postData === undefined || obj.postData === null) {
        obj.postData = {};
        hasPostData = false;
    }
    else {
        hasPostData = true;
        if (typeof obj.postData === 'string')
            obj.postData = DrDocWeb.QueryStrToObject(obj.postData);
    }

    // --
    // 4. GET Data laden
    let hasGetData = false;
    if (obj.getData === undefined || obj.getData === null) {
        obj.getData = {};
        hasGetData = false;
    }
    else {
        hasGetData = true;

        // Falls obj.getData ein Query-String ist, in ein Objekt verwandeln
        if (typeof obj.getData === 'string') {
            obj.getData = DrDocWeb.QueryStrToObject(obj.getData);
            //console.log('LoadComponent: QueryStrToObject: ', obj.getData)
        }
    }

    /// TODO: viewName aus URL oder aus Element obj.targetElement laden
    let viewName = 'None'; // 'Inline';
    //getArgs['prop'] = props;
    //obj.getData['prop_orig'] = nodeId;
    if (!DrDocWeb.IsNullOrEmpty(obj.view)) {
        viewName = obj.view;
    }
    if (DrDocWeb.IsNullOrEmpty(obj.getData['view'])) {
        obj.getData['view'] = viewName;
    }

    if (obj.ignoreUnloadEvent === true) {
        window.onbeforeunload = undefined;
    }

    let attrElementsArr = [];

    // --
    // 5. Source Element / Node-id + Formular-Daten laden

    // Form Daten in obj.getData setzen
    // Alle Felder mit "$" am Anfang werden direkt als "<FieldName>" übernommen, alle anderen in "form_<FieldName>" umgewandelt
    if (obj.sourceElement !== undefined && obj.sourceElement !== null) {
        if (typeof obj.sourceElement === 'string') {
            obj.sourceElement = Node.GetElement(obj.sourceElement);
        }
        if (obj.sourceElement !== undefined && obj.sourceElement !== null) {
            // Existiert ein "beforeunload" Event auf dem Element?
            if (obj.ignoreUnloadEvent !== true && //(obj.ignoreUnloadEvent == undefined || obj.ignoreUnloadEvent == null || obj.ignoreUnloadEvent == false) &&
                obj.sourceElement.beforeunload !== undefined && obj.sourceElement.beforeunload !== null && typeof obj.sourceElement.beforeunload === 'function') {
                // Wenn nicht true (also false oder undefined) zurückgegeben wurde, dann abbrechen.
                if (obj.sourceElement.beforeunload() !== true) {
                    return undefined;
                }
            }

            //if (!hasPostData) // && !hasGetData)
            //    Node.ParseFormData(obj.sourceElement, obj.getData, obj.postData, obj.formFieldsOr);
        }
        else {
            console.warn('Node.LoadComponent', 'obj.sourceElement == undefined');
        }
        attrElementsArr.push(obj.sourceElement);
    }
    else {
        console.warn('Node.LoadComponent', 'obj.sourceElement (DOM) == undefined');
    }

    // --

    if (!hasPostData)
        Node.ParseFormData(obj.sourceElement, obj.getData, obj.postData, obj.formFieldsOr, obj.writeToGetData);

    // --

    // DOM Node Objekt löschen, damit es nicht zwei mal im DOM vorkommt
    //DrDoc.store.set('node|' + nodeId, undefined);

    // --
    // Daten aus Target-Element lesen

    if (obj.targetElement !== undefined && obj.targetElement !== null) {
        // Existiert ein "beforeunload" Event auf dem Element?
        if (obj.ignoreUnloadEvent !== true && //(obj.ignoreUnloadEvent == undefined || obj.ignoreUnloadEvent == null || obj.ignoreUnloadEvent == false) &&
            obj.targetElement.beforeunload !== undefined && obj.targetElement.beforeunload !== null && typeof obj.targetElement.beforeunload === 'function') {
            // Wenn nicht true (also false oder undefined) zurückgegeben wurde, dann abbrechen.
            if (obj.targetElement.beforeunload() !== true) {
                return undefined;
            }
        }
        attrElementsArr.push(obj.targetElement);
    }

    for (let attrElement of attrElementsArr) {
        //console.log("node form ", attrElement, attrElement.attributes);
        // Html/DOM Attribute aus dem "attrElement" extrahieren und in POST/GET-Parameter mergen
        if (attrElement == null || attrElement == undefined || attrElement.attributes == undefined)
            continue;
        var attrs = attrElement.attributes;
        if (attrs != undefined && attrs != null && attrs.length > 0) {
            //if (!hasPostData) {
            for (var i = attrs.length - 1; i >= 0; i--) {
                if (attrs[i].name.indexOf('node-post-') === 0) {
                    let fieldName = attrs[i].name.substring('node-post-'.length);
                    //console.log("node form post " + fieldName + " -> " + attrs[i].value);
                    obj.postData[fieldName] = attrs[i].value;
                }
            }
            //}

            //if (!hasGetData) {
            for (var i = attrs.length - 1; i >= 0; i--) {
                if (attrs[i].name.indexOf('node-get-') === 0) {
                    let fieldName = attrs[i].name.substring('node-get-'.length);
                    //console.log("node form get " + fieldName + " -> " + attrs[i].value);
                    obj.getData[fieldName] = attrs[i].value;
                }
            }
            //}
        }

        let attrTitle = attrElement.getAttribute('node-title');
        if (!DrDocWeb.IsNullOrEmpty(attrTitle)) {
            obj.title = attrTitle;
        }

        // Navigation
        let attrNav = attrElement.getAttribute('node-nav');
        if (!DrDocWeb.IsNullOrEmpty(attrNav)) {
            // Url für den Root WebNode
            //let navUrl = DrDocWeb.GetRequestUrl(url.split('|')[0], obj.getData);
            //console.log('NAVIGATE Node B: ', obj.title, navUrl, attrElement);
            obj.nav = attrNav;
        }
        else {
            //console.log('X NAVIGATE Node Target elem ', attrElement);
        }
    }

    // navigieren
    if (obj.nav !== undefined && obj.nav !== null && !(obj.nav === 'false' || obj.nav === '0' || obj.nav === false)) {
        Node.NavigateComponent(nodeId, obj);
    }

    // Scroll Position und Focus merken, um diese nach dem Laden wiederherzustellen
    let scrollTop = obj.sourceElement != undefined && obj.sourceElement != null ? obj.sourceElement.scrollTop : 0;
    let scrollLeft = obj.sourceElement != undefined && obj.sourceElement != null ? obj.sourceElement.scrollLeft : 0;
    let activeElementId = document.activeElement != null ? document.activeElement.id : null;

    return Node._initTargetElement(obj.title, nodeId, obj.targetElement, obj.newWindow)
        //.catch(function(err) {
        //    console.warn('LoadComponent X1', err);
        //})
        .then(function (targetElement) {
            if ((obj.sourceElement !== undefined && obj.sourceElement !== null) && (targetElement !== undefined && targetElement !== null)) {
                targetElement._triggerElement = obj.sourceElement;
                obj.sourceElement._triggerElement = targetElement;
            }

            targetElement.UpdateComponent = function () {
                obj.targetElement = targetElement;
                //if (obj.getData == undefined || obj.getData == null)
                obj.getData.update = 'true';
                //Node.UpdateComponent(nodeId);
                //return Node.LoadComponent(obj.title, obj.sourceElement, targetElement, obj.getData, obj.postData);
                return Node.LoadComponent(obj);
            };

            if (obj.requestMethod == undefined || obj.requestMethod == null || obj.requestMethod.length == 0) {
                //obj.requestMethod = 'GET';
                obj.requestMethod = 'POST';
            }

            //console.log('LoadComponent', 'send...');

            // Dr.DOC Server anfragen
            // DrDocWeb.Send = function (method, url, getData, postData, parseAs, sendAs, cookie, retAsync)
            return DrDocWeb.Send(obj.requestMethod, url, obj.getData, obj.postData, undefined, undefined, undefined, true)
                //.catch(function(err) {
                //    console.warn('LoadComponent X2', err);
                //})
                .then(function (response) {
                    if (targetElement === null || targetElement === undefined) {
                        // Öffnet ein Modal, falls kein DOM-Element vorhanden ist.
                        console.warn('LoadComponent', 'targetElement == null');
                    }
                    else {
                        //console.log('LoadComponent', 'Response ok');
                        //DrDocWeb.setInnerHTML(targetElement, '...');

                        //DrDocWeb.setInnerHTML(targetElement, response);
                        //DrDocWeb.EventFire(targetElement, 'NodeLoaded');
                        if (obj.ignoreLoadEvent !== true)
                            DrDocWeb.EventFire(targetElement, 'NodeUnloaded');

                        //targetElement.innerHTML = response;
                        //var v_elem = document.createElement('div');
                        var doc = (targetElement.ownerDocument || document);
                        var v_elem = doc.createElement('div');
                        v_elem.innerHTML = response;
                        //var v_elem_child = DrDocWeb.FindChildElement(v_elem, Node.ATTR_NAME, nodeId);
                        var v_elem_child = Node.GetElement(nodeId, v_elem);
                        if (v_elem_child !== undefined && v_elem_child !== null) {
                            //console.log(`LoadComponent: DOM-Element ${Node.ATTR_NAME}="${nodeId}"`, 'target', targetElement, v_elem, v_elem_child, response);
                            //targetElement.innerHTML = v_elem_child.innerHTML;
                            // über setInnerHTML aufrufen, damit Scripts ausgeführt werden können
                            //--DrDocWeb.setInnerHTML(targetElement, v_elem_child.outerHTML);
                            DrDocWeb.setInnerHTML(targetElement, v_elem_child.innerHTML);

                            // onLoad Event "DOMContentLoaded" ausführen
                            //DrDocWeb.EventFire(document, 'DOMContentLoaded');
                            //DrDocWeb.EventFire(targetElement, 'NodeLoaded');
                        }
                        else {
                            console.warn(`LoadComponent: DOM-Element ${Node.ATTR_NAME}="${nodeId}" konnte nicht gefunden werden!`, ' / response: ', response, ' / v_elem: ', v_elem, ' / targetElement: ', targetElement, ' / sourceElement: ', obj.sourceElement);
                            //targetElement.outerHTML = v_elem.innerHTML;
                            //DrDocWeb.setInnerHTML(targetElement, v_elem.innerHTML);
                            if (obj.exact === true)
                                DrDocWeb.setInnerHTML(targetElement, `Zugriff verweigert: Element ${Node.ATTR_NAME} ${nodeId} konnte nicht gefunden werden!`);
                            else
                                DrDocWeb.setInnerHTML(targetElement, v_elem.innerHTML);
                        }
                        if (obj.ignoreLoadEvent !== true) {
                            DrDocWeb.EventFire(targetElement, 'NodeLoaded');
                            /*let onNodeLoadedEventNodes = targetElement.querySelectorAll('[onnodeloaded]');
                            if (onNodeLoadedEventNodes != null && onNodeLoadedEventNodes.length > 0)
                            {
                                console.log('Node.onnodeloaded: ', onNodeLoadedEventNodes);
                                for (let onNodeLoadedEventNode of onNodeLoadedEventNodes)
                                {
                                    let onNodeLoadedEventCode = onNodeLoadedEventNode.getAttribute('onnodeloaded');
                                    if (DrDocWeb.IsNullOrEmpty(onNodeLoadedEventCode))
                                        continue;

                                }
                            }*/
                        }

                        if (obj.sourceElement != undefined && obj.sourceElement != null) {
                            obj.sourceElement.scrollTop = scrollTop;
                            obj.sourceElement.scrollLeft = scrollLeft;
                        }

                        if (!DrDocWeb.IsNullOrEmpty(activeElementId)) {
                            //console.log('LoadComponent: Reload active elem', activeElementId, document.getElementById(activeElementId));
                            var activeElementTmp = document.getElementById(activeElementId);
                            if (activeElementTmp != undefined && activeElementTmp != null) {
                                document.activeElement = activeElementTmp;
                                if (activeElementTmp.focus !== undefined && typeof activeElementTmp.focus === 'function')
                                    activeElementTmp.focus();
                            }
                        }

                        // DOM Node in Store setzen
                        //DrDoc.store.set('node|' + nodeId, targetElement);
                    }
                })
                .catch(Node._onErrorLoadElem(obj.title, nodeId, targetElement));

        });
};

Node.ParseFormData = function (sourceElement, getData, postData, formFieldsOr, writeToGetData) {
    let splitter_char = formFieldsOr === true ? '|' : String.fromCharCode(1);

    let formData = DrDocWeb.ClosestFormToObject(sourceElement, splitter_char);

    // Formular-Daten in GET Parameter übertragen
    if (formData !== undefined && formData !== null) {

        //console.log('Node.ParseFormData: ', formData);

        for (let fieldName in formData) {
            let fieldValue = formData[fieldName];
            // Leere Feldwerte überspringen
            if (formFieldsOr === true) {
                if (fieldValue === undefined || fieldValue === null || fieldValue === '')
                    continue;
                //else
                //    fieldValue = fieldValue.replace(/[\|]+$/, '');
                //fieldValue = fieldValue.replace(/[\s\|]+$/, '');
            }

            // Formular-Daten kommen in POST
            // Formulardaten mit Prefix "$" kommen in GET
            if (fieldName.substring(0, 1) === '$') {
                getData[fieldName.substring(1)] = fieldValue;
            }
            else {
                if (writeToGetData === true)
                    getData['field_' + fieldName] = fieldValue;
                else
                    postData[fieldName] = fieldValue;
            }
        }
    }
    else {
        //console.warn('Node.LoadComponent', 'sourceElement->form == undefined', 'sourceElement:', sourceElement);
    }
    return formData;
};
Node.SetFormFieldGetData = function (getObj, data) {
    //console.log('Node.SetFormFieldGetData() 1: ', getObj, data);
    if (data != undefined && data != null) {
        if (typeof data === 'string') {
            // Wenn "data" ein "String" ist, dann annehmen, dass die Feld-Namen im Format "field_<FieldName>" ist
            data = DrDocWeb.QueryStrToObject(data);
            for (let i in data) {
                getObj[i] = data[i];
            }
        }
        else {
            // "data" ist ein Object, daher "field" voranstellen
            for (let name in data) {
                if (name[0] == '$')
                    getObj[name.substring(1)] = data[name];
                else
                    getObj['field_' + name] = data[name];
            }
        }
        //console.log('Node.SetFormFieldGetData() 2: ', getObj, data);
    }
};

Node._setElementStateLoading = function (targetElement) {
    if (targetElement == undefined || targetElement == null)
        return;
    // "Loading" Info in das Element schreiben
    // Manche Elemente müssen gesondert behandelt werden
    switch (targetElement.tagName.toLowerCase()) {
        case 'button':
        case 'input':
            targetElement.innerHTML = 'loading..';
            break;

        case 'select':
            targetElement.innerHTML = '<option>loading..</option>';
            break;

        default:
            targetElement.innerHTML = `
    <div class="d-flex justify-content-center align-items-center align-self-center p-3">
        <div class="spinner-border text-primary-subtle" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
        <!--<br /><b><i class="bi bi-hourglass-split"></i>&nbsp;&nbsp;&nbsp;Wird geladen...</b>-->
    </div>`;
            break;
    }
};

Node._onErrorLoadElem = function (title, nodeId, targetElement) {
    return function (err) {
        console.warn('ERROR Node.LoadComponent / Node._onErrorLoadElem', err);
        //console.log('ERROR / LoadComponent 1', err);
        DrDocWeb.ModalError(`Fehler für: ${title}`, `Komponente "${Node.ATTR_NAME}"="${nodeId}" konnte nicht abgerufen werden!`);
        //DrDocWeb.ModalError(`Fehler für: ${title} konnte nicht abgerufen werden!`);

        //alert(`Fehler für: ${title}`, `Komponente "${Node.ATTR_NAME}"="${nodeId}" konnte nicht abgerufen werden!`);

        if (targetElement != undefined && targetElement != null) {
            var origInnerHtml = targetElement.innerHTML;

            // Im Fehlerfall die Kompontente zurücksetzen
            if (origInnerHtml.length > 0) {
                origInnerHtml = `<b>Komponente konnte nicht abgerufen werden! Die Komponente wird auf den vorherigen Wert zurückgesetzt. Bitte Internetverbindung überprüfen.</b>
        <br />
        <button class="btn btn-lg btn-primary" onclick="Node.GetElement('${nodeId}').UpdateComponent();">Neu laden</button>
        <br />${origInnerHtml}`;
            }
            else {
                origInnerHtml = `<b>Bitte Internetverbindung überprüfen.</b>
        <br />
        <button class="btn btn-lg btn-primary" onclick="Node.GetElement('${nodeId}').UpdateComponent();">Neu laden</button>`;
            }
            targetElement.innerHTML = origInnerHtml;
        }
        else {
            console.warn('ERROR Node.LoadComponent / Node._onErrorLoadElem: targetElement == null', err);
        }
        //reject(err);
    };
};

Node._initTargetElement = function (title, nodeId, targetElement, newWindow) {

    let origInnerHtml = '';

    return new Promise(function (resolve, reject) {
        //try
        //{
        // falls kein "targetElement" übergeben wurde, ein Modal erstellen oder ein neues Fenster öffnen.
        if (targetElement === undefined || targetElement === null || newWindow === true) {
            if (newWindow === true) {
                // Get New Window
                return Node._getTempNodeWindowSelectElement(title, nodeId).then(function (targetElementArg) {
                    targetElement = targetElementArg;
                    Node._setElementStateLoading(targetElement);
                    resolve(targetElementArg);
                }).catch(reject);
            }
            else {
                // falls kein "targetElement" übergeben wurde, ein Modal erstellen.
                targetElement = document.createElement('div');
                targetElement.setAttribute(Node.ATTR_NAME, nodeId);
                Node._setElementStateLoading(targetElement);
                DrDocWeb.Modal(title, targetElement, { fullScreen: false, size: 'xl' });
            }
        }
        else {
            // Original-Element für den Fehlerfall zwischenspeichern
            origInnerHtml = targetElement.innerHTML;
            Node._setElementStateLoading(targetElement);
        }

        resolve(targetElement);

        /*}
        catch (err)
        {
            onError(err);
        }*/
    })
        .catch(Node._onErrorLoadElem(title, nodeId, targetElement));
};

// Node DOM Element im Temp Window wählen
Node._getTempNodeWindowSelectElement = function (title, nodeId) {
    return new Promise(function (resolve, reject) {
        Node._getTempNodeWindow(nodeId).then(function (newWindow) {
            newWindow.title = title;
            var newWindowDoc = newWindow.document.documentElement;
            console.log('New Window Target Elem', newWindowDoc);
            resolve(newWindowDoc);
        }).catch(reject);
    });
};

// Temp Window für den Node öffnen und Promis zurückgeben
Node._getTempNodeWindow = function (nodeId) {
    return new Promise(function (resolve, reject) {
        try {
            // falls kein "targetElement" übergeben wurde, ein neues Fenster öffnen.
            //var newWindow = window.open(url, '_blank'); //'/node/')

            var thisDocHtml = null; //document.documentElement.innerHTML;

            // Fenster speichern in "window._comWindow[Node-Path]"
            if (window._comWindow === undefined || window._comWindow === null) {
                window._comWindow = {};
            }
            if (window._comWindowCounter === undefined || window._comWindowCounter === null) {
                window._comWindowCounter = 0;
            }

            var newWindow = null;
            if (window._comWindow[nodeId] !== undefined && window._comWindow[nodeId] !== null && window._comWindow[nodeId].closed === false) {
                newWindow = window._comWindow[nodeId];
                newWindow.focus();
                resolve(newWindow);
            }
            else {
                window._comWindowCounter++;

                newWindow = window.open('/node/system/empty#nr-' + window._comWindowCounter, nodeId + " - " + window._comWindowCounter, 'width=1200, height=1000');
                //newWindow = window.open('about:blank', nodeId, 'width=700, height=800');
                window._comWindow[nodeId] = newWindow;
                newWindow.addEventListener('load', function (e) {
                    console.log('_getTempNodeWindow: New Window has been loadad', e, e.target.documentElement);
                    newWindow.focus();
                    resolve(newWindow);
                }, true);
                newWindow.addEventListener('beforeunload', function (e) {
                    if (window._comWindow != undefined)
                        window._comWindow[nodeId] = undefined;
                }, false);
                if (thisDocHtml != null && thisDocHtml != undefined) {
                    var newWindowDoc = newWindow.document.open();
                    newWindowDoc.write(thisDocHtml);
                    newWindowDoc.close();
                }
                //console.log('New Window ', newWindow, newWindow.documentElement, newWindowDoc);
                console.log('New Window ', nodeId, newWindow, newWindowDoc, newWindow.document, newWindow.document.documentElement);
                /*while (newWindow.document.readyState != 'complete')
                {
                    // wait..
                }*/
            }
        }
        catch (err) {
            reject(err);
        }
    });
};


// Aktualisiert alle Nodes, die diesen Node im NodePath enthalten
Node.UpdateComponent = function (nodeName) {
    let nodeElem = Node.GetElement(nodeName);
    if (nodeElem != undefined && nodeElem != null && typeof nodeElem.UpdateComponent === 'function') {
        console.log('Node.UpdateComponent: ', nodeName, nodeElem);
        return nodeElem.UpdateComponent();
    }
    else {
        console.log('Node.UpdateComponent: ', nodeName, 'Nicht gefunden!');
        return Node.LoadComponent({ title: 'Komponente aktualisieren', sourceElement: nodeElem, targetElement: nodeElem });
    }

    return Node.LoadComponent({ title: 'Komponente aktualisieren', sourceElement: Node.GetElement(nodeName), targetElement: Node.GetElement(nodeName) });
};


Node._lastNavCom = {
    nodeId: '',
    getData: '',
    postData: '',
};
// History Verlauf
Node.NavigateComponent = function (nodeId, obj) // navSourceElem)
{
    var replace = obj.nav == 'replace';

    var state = DrDocWeb.CloneCopy(obj);
    state.sourceElement = nodeId;
    state.targetElement = nodeId;
    state.action = 'nav';
    state.nav = undefined;

    if (Node._lastNavCom.nodeId == nodeId && Node._lastNavCom.getData == DrDocWeb.ObjectToQueryStr(state.getData) && Node._lastNavCom.postData == DrDocWeb.ObjectToQueryStr(state.postData))
        return;

    Node._lastNavCom.nodeId = nodeId;
    Node._lastNavCom.getData = DrDocWeb.ObjectToQueryStr(state.getData);
    Node._lastNavCom.postData = DrDocWeb.ObjectToQueryStr(state.postData);

    var navUrl = '/node/' + nodeId.split('|')[0] + '?' + DrDocWeb.ObjectToQueryStr(state.getData);
    var navTitle = !DrDocWeb.IsNullOrEmpty(state.title) ? state.title : document.title;

    var navSourceElem = Node.GetElement(nodeId);
    if (navSourceElem == undefined || navSourceElem == null) {
        console.log('Node.NavigateComponent: Node id not found ', navTitle, navUrl, nodeId);
        return;
    }
    console.log('Node.NavigateComponent: PUSH STATE: ', navTitle, navUrl, nodeId);

    /*var setState = {
        //html: sourceElem.innerHTML,
        //html: navSourceElem.innerHTML,
        nodeId: nodeId,
        pageTitle: navTitle,
        url: navUrl
    };*/

    try {
        if (replace)
            window.history.replaceState(state, navTitle, navUrl);
        else
            window.history.pushState(state, navTitle, navUrl);
    }
    catch (ex) {
        console.warn('Node.NavigateComponent:', nodeId, obj, ex);
    }

    //if (window.onpopstate != Node.OnNavigateComponentEvent)
    //    window.onpopstate = Node.OnNavigateComponentEvent;

    window.removeEventListener('popstate', Node.OnNavigateComponentEvent);
    window.addEventListener('popstate', Node.OnNavigateComponentEvent);
};

Node.OnNavigateComponentEvent = function (e)
//window.addEventListener('popstate', function(e)
{
    if (e.state) {

        /*if (e.state.url == navUrl)
        {
            //console.log('window.onpopstate->e.state: ENDE! ', e, e.state);
            return;
        }*/
        //document.getElementById("content").innerHTML = e.state.html;

        //var navSourceElem = Node.GetElement(e.state.nodeId);
        //navSourceElem.innerHTML = e.state.html;
        //document.title = e.state.pageTitle;

        if (e.state.action == 'nav') {
            console.log('Node.OnNavigateComponentEvent: window.onpopstate->e.state:', e.state);
            e.preventDefault();
            Node.LoadComponent(e.state);
        }
    }
    else {
        //console.log('window.onpopstate->e: BAD STATE ', e);
    }
};


Node.SaveThis = function (node_id, node_prop_name, node_prop_value, node_prop_type, node_prop_inherit, new_name) {
    if (DrDocWeb.IsNullOrEmpty(node_id)) {
        console.error('Node.Save: Kein Argument für node_id angegeben!');
        return;
    }

    // HTTP PUT
    // POST Object = {
    //    __name: <Name>
    //    __prototype: <Prototype>
    //    <PropertyName>: <PropertyValue>
    //    $<PropertyName>: <PropertyType>
    //    ~<OldPropertyName>: <NewPropertyName>
    //    -<RemovePropertyName>: ''
    //    +<InheritPropertyName>: true
    //}

    let postData = {};

    if (!DrDocWeb.IsNullOrEmpty(new_name)) {
        postData['__name'] = new_name;
    }

    //if (!DrDocWeb.IsNullOrEmpty(new_prototype)) {
    //    postData['__prototype'] = new_prototype;
    //}

    if (!DrDocWeb.IsNullOrEmpty(node_prop_name)) {
        postData[node_prop_name] = !DrDocWeb.IsNullOrEmpty(node_prop_value) ? node_prop_value : '';

        // Property Type
        if (!DrDocWeb.IsNullOrEmpty(node_prop_type))
            postData['$' + node_prop_name] = node_prop_type;

        // Property vererben
        if (node_prop_inherit != null && node_prop_inherit != undefined)
            postData['+' + node_prop_name] = node_prop_inherit == true;
    }

    return Node.LoadComponent({
        //getData,
        postData: postData,
        view: 'Inline',
        targetElement: node_id, // + '|' + node_prop_name,
        sourceElement: node_id,
        //sourceElement: (!DrDocWeb.IsNullOrEmpty(node_prop_name) ? (node_id + '|' + node_prop_name) : node_id),
        requestMethod: 'PUT',
    });

    //let path = '/node/' + node_id;
    //console.log('SendValue, load inline editor', node_id, node_id, path, getData, postData);

    //return DrDocWeb.Send('PUT', path, getData, postData).then(function (data) {
    //    return Node.UpdateComponent(node_id);
    //});
};
Node.Save = function (node_id, node_prop_value, node_prop_type, ode_prop_inherit, new_name) {
    if (node_id == undefined || node_id == null || node_id == '') {
        console.error('Node.Save: Kein Argument für node_id angegeben!');
        return;
    }

    // node_id = page_home|menu_main|de/property

    let node_id_path_arr = node_id.split('|');
    let node_prop_name = node_id_path_arr[node_id_path_arr.length - 1];
    node_id_path_arr.splice(node_id_path_arr.length - 1, 1);
    let node_id_parent = node_id_path_arr.join('|');

    // =>
    // node_id_parent = page_home|menu_main
    // node_prop_name = de/property

    return Node.SaveThis(node_id_parent, node_prop_name, node_prop_value, node_prop_type, ode_prop_inherit, new_name);
};


//Node.SendElementValue = function(path, node_id, node_name, element, elemBase)
Node.SendElement = function (node_id, element, elemBase, parser) {
    let elem = element !== undefined && element !== null && typeof element === 'string' ? DrDocWeb.GetElement(elemBase, element) : element;
    if (element == undefined || element == null) {
        console.warn('Node.SendElementValue: Element not found (by id)!', element, elem);
        return false;
    }

    //let elem = Node.GetElement(element);
    let value = parser(elem);

    //console.log('Node.SendElementValue: ', 'Path: ', path, 'Node-ID: ', element, 'Value: ', value, 'Elements: ', elem);
    //return Node.Save(path, node_id, node_name, value, '');
    return Node.Save(node_id, value, undefined, undefined);
};
Node.SendElementContentMarkdown = function (node_id, element, elemBase) {
    return Node.SendElement(node_id, element, elemBase, function (_elem) {
        console.log('Node.SendElementContentMarkdown', element, _elem, _elem.parentNode, _elem.tagName);
        let ret_value = _elem.value;
        return ret_value;
    });
};
Node.SendElementContentHtml = function (node_id, element, elemBase) {
    return Node.SendElement(node_id, element, elemBase, function (_elem) {
        console.log('Node.SendElementContent', element, _elem, _elem.parentNode, _elem.tagName);
        let ret_value = _elem.innerHTML;
        ret_value = ret_value.replaceAll('<br data-mce-bogus=&quot;1&quot;>', '<br />');
        ret_value = ret_value.replaceAll('<br data-mce-bogus="1">', '<br />');
        ret_value = ret_value.replaceAll('&lt;br data-mce-bogus=&quot;1&quot;&gt;', '<br />');
        ret_value = ret_value.replaceAll('&lt;br data-mce-bogus="1"&gt;', '<br />');
        return ret_value;
    });
};
Node.SendElementContentText = function (node_id, element, elemBase) {
    return Node.SendElement(node_id, element, elemBase, function (_elem) {
        console.log('Node.SendElementContent', element, _elem, _elem.parentNode, _elem.tagName);
        let ret_value = _elem.InnerText !== undefined ? _elem.InnerText : _elem.innerHTML;
        console.log('Node.SendElementContent', 'Text 1', ret_value);
        ret_value = ret_value.replaceAll('&nbsp;', " ");
        ret_value = ret_value.replaceAll('&lt;', "<");
        ret_value = ret_value.replaceAll('&gt;', ">");
        ret_value = ret_value.replaceAll('<br data-mce-bogus=&quot;1&quot;>', "\r\n");
        ret_value = ret_value.replaceAll('<br data-mce-bogus="1">', "\r\n");
        ret_value = ret_value.replaceAll('&lt;br data-mce-bogus=&quot;1&quot;&gt;', "\r\n");
        ret_value = ret_value.replaceAll('&lt;br data-mce-bogus="1"&gt;', "\r\n");

        ret_value = ret_value.replaceAll('<br>', "\r\n");
        ret_value = ret_value.replaceAll('&lt;br&gt;', "\r\n");
        ret_value = ret_value.replaceAll('<br/>', "\r\n");
        ret_value = ret_value.replaceAll('<br />', "\r\n");

        ret_value = ret_value.replaceAll('</p>', "\r\n");
        ret_value = ret_value.replaceAll('<p>', '');
        console.log('Node.SendElementContent', 'Text 2', ret_value);
        return ret_value;
    });
};
Node.SendElementChecked = function (node_id, element, elemBase) {
    return Node.SendElement(node_id, element, elemBase, function (_elem) {
        console.log('SendElementChecked', _elem);
        return _elem.checked ? 'true' : 'false';
    });
};
Node.SendElementValue = function (node_id, element, elemBase) {
    return Node.SendElement(node_id, element, elemBase, function (_elem) {
        console.log('SendElementValue', _elem);
        return _elem.value;
    });
};

//Node.SendElementName = function(path, node_id, new_name)
Node.SendElementName = function (node_id, new_name, elemBase) {
    // ist new_name ein Element?
    if (new_name !== undefined && typeof new_name !== 'string' && new_name.value !== undefined) {
        new_name = new_name.value;
    }
    //return Node.Save(path, node_id, undefined, undefined, new_name);
    return Node.Save(node_id, undefined, undefined, new_name);
};



